import { LayoutInterface } from '@x/types';
import { useContext } from 'react';
import { LayoutContext } from 'stores';

export function useLayout(): LayoutInterface {
  return useContext(LayoutContext);
}
